import currencies from 'constants/currencies';

import trialOfferGWPMixedWithSkincareMinisModalContent from 'assets/content/promotions/trialOfferGWPMixedWithSkincareMinisModal';
import imageGift from 'assets/images/promotions/trial-offer-petit-tote-gwp-promotion-modal.jpg';

const popUpConditions = (
  <>
    See the full promotion terms and conditions{' '}
    <a
      data-click="return-policy"
      data-from="trial-offer-v2-hc-sc-pop-up"
      href="https://prose.com/faq/5ee3386a083d64001a9ffc68"
      target="_blank"
    >
      here
    </a>
    .
  </>
);

const bottomModalConditions = (
  <>
    See the full promotion terms and conditions{' '}
    <a href="https://prose.com/faq/5ee3386a083d64001a9ffc68" target="_blank">
      here
    </a>
    .
  </>
);

const content = {
  banner: trialOfferGWPMixedWithSkincareMinisModalContent.banner,
  popUpModal: {
    [currencies.USD]: {
      ...trialOfferGWPMixedWithSkincareMinisModalContent.popUpModal[currencies.USD],
      headerTitle: 'MEMORIAL DAY SALE',
      image: imageGift,
      conditions: popUpConditions,
    },
    [currencies.CAD]: {
      ...trialOfferGWPMixedWithSkincareMinisModalContent.popUpModal[currencies.CAD],
      headerTitle: 'MEMORIAL DAY SALE',
      image: imageGift,
      conditions: popUpConditions,
    },
  },
  bottomModal: {
    [currencies.USD]: {
      ...trialOfferGWPMixedWithSkincareMinisModalContent.bottomModal[currencies.USD],
      conditions: bottomModalConditions,
    },
    [currencies.CAD]: {
      ...trialOfferGWPMixedWithSkincareMinisModalContent.bottomModal[currencies.CAD],
      conditions: bottomModalConditions,
    },
  },
} as const;

export default content;
